import { UPDATE_LIST } from "../types/list";

const initialState = {};
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_LIST:
      return { ...state, ...payload };
    default:
      return state;
  }
}
